import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex justify-end items-center" }
const _hoisted_2 = { class: "fadeInRight transition-all fixed right-0 top-0 h-full z-40 shadow-lg bg-white flex justify-start items-start flex-col p-4 w-full md:w-2/5 xl:w-1/3 lg:1/5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeContentState && _ctx.changeContentState(...args))),
      class: "z-10 fixed w-screen h-screen right-0 top-0 opacity-50"
    }),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "rightMenuContent")
    ])
  ]))
}